import { SET_PAGE_INFO } from './types';

const setPageInfo = (payload) => ({
	type: SET_PAGE_INFO,
	payload
});

export default setPageInfo;
